import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BusinessLoansFormFields } from "web_myplann/Portfolio/Forms/BusinessLoansForm/BusinessLoansFormFields";
import { useCreateBusinessLoansForm } from "web_myplann/Portfolio/Forms/BusinessLoansForm/useCreateBusinessLoansForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateBusinessLoansForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateBusinessLoansForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<BusinessLoansFormFields
				control={form.control}
				collapseParams
				showRemainsToPay
			/>
		</PortfolioFormShell>
	);
};
